//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import { orange } from '@mui/material/colors';
import { Box } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { Fonts } from '@projectK/constants/AppEnums';
import PropTypes from 'prop-types';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import jwtAxios from '@projectK/services/auth/JWT';
import useMediaQuery from '@mui/material/useMediaQuery';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useRolePermissions } from '@projectK/context/RolesProvider';

const getWidthHeight = (onClick) => {
  return onClick ? 32 : 40;
};
const getBackgroundColor = (companyTheme) => {
  return companyTheme ? companyTheme.primary.main : orange[500];
};

const getUserAvatar = (user) => {
  if (user?.displayName) {
    return user?.displayName.charAt(0).toUpperCase();
  }
  if (user?.email) {
    return user?.email.charAt(0).toUpperCase();
  }
};

const UserInfo = ({ color, logo, onClick }) => {
  const { user } = useAuthUser();
  const isMobile = useMediaQuery('(max-width:1199px)');
  const { roleData } = useRolePermissions();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
  };
  const capitalizeFirstLetter = (str = '') => {
    if (typeof str !== 'string') return '';
    return str
      .split(/[\s_]+/) // split on spaces or underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await jwtAxios.get(`/users/${user.id}`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchSettings();
  }, []);

  const companyTheme = CompanyTheme();

  const [generalSettings, setGeneralSettings] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await jwtAxios.get(`/app-settings/`);
      const { data } = response;
      setGeneralSettings(data.basic);
    } catch (error) {
      // Handle error
      console.error('Error fetching appearance settings:', error);
    }
  };
  return (
    <>
      {/* logo */}
      {isMobile && logo ? (
        <Box
          sx={{
            width: { xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)' },
            alignItems: 'center',
            margin: 'auto',
            borderBottom: '1px solid #aaa',
          }}
          className='home-logo-info'
        >
          <Box
            sx={{
              alignItems: 'center',
              padding: 3,
            }}
          >
            {generalSettings?.home_logo_url && (<img
              src={`${process.env.NX_CLOUD_FRONT_URL}/${generalSettings?.home_logo_url}`}
              alt='home_logo'
            />)}
          </Box>
        </Box>
      ) : null}
      {/* logo */}
      <Box
        // onClick={handleClick}
        sx={{
          py: 3,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        className='user-info-view'
      >
        <Box
          sx={{
            py: 0.5,
          }}
        >
          {settings?.user_profile_pic ? (
            <Avatar
              sx={{
                width: getWidthHeight(onClick),
                height: getWidthHeight(onClick),
                fontSize: 24,
                backgroundColor: getBackgroundColor(companyTheme),
              }}
              src={settings?.user_profile_pic ? `${process.env.NX_CLOUD_FRONT_URL}/${settings?.user_profile_pic}` : null}
              onClick={handleClick}
            />
          ) : (
            <Avatar
              sx={{
                width: getWidthHeight(onClick),
                height: getWidthHeight(onClick),
                fontSize: 24,
                backgroundColor: getBackgroundColor(companyTheme),
              }}
              onClick={handleClick}
            >
              {getUserAvatar(user)}
            </Avatar>
          )}
        </Box>
        {!isMobile && !onClick && (
          <Box
            sx={{
              width: { xs: 'calc(100% - 62px)', xl: 'calc(100% - 72px)' },
              ml: 4,
              color: color,
            }}
            className='user-info'
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  mb: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 16,
                  fontWeight: Fonts.MEDIUM,
                  color: '#A9A9A9',
                }}
                component='span'
              >
                {settings?.first_name} {' '} {settings?.last_name}
                {/* User info component in sidenav */}
              </Box>
            </Box>
            <Box
              sx={{
                mt: -0.5,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: '#A9A9A9',
              }}
            >
              {roleData?.role_name
                ? capitalizeFirstLetter(roleData?.role_name)
                : 'Administrators'}
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default UserInfo;

UserInfo.defaultProps = {
  color: 'text.secondary',
};

UserInfo.propTypes = {
  color: PropTypes.string,
  logo: PropTypes.string,
  onClick: PropTypes.func,
};
